import { useTheme } from 'styled-components'

import { Chip, Switch, Text } from '@reveni-io/reveni-ui'

import { getCriterionChipColors } from './helpers'
import * as Styles from './styles'

const ScenarioCriterion = ({ criterion, onToggle }) => {
  const theme = useTheme()

  const chipColors = getCriterionChipColors(theme, criterion.isActive)

  const handleToggle = () => onToggle(criterion.id)

  return (
    <Styles.Container>
      <Styles.Header>
        <Text type="bodyMMedium">{criterion.label}</Text>
        <Switch checked={criterion.isActive} onChange={handleToggle} label="" />
      </Styles.Header>
      <Styles.Blocks>
        {criterion.blocks.map(block => (
          <Chip
            key={block.blockId}
            label={block.name}
            backgroundColor={chipColors.backgroundColor}
            color={chipColors.color}
          />
        ))}
      </Styles.Blocks>
    </Styles.Container>
  )
}

export default ScenarioCriterion
